import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import React from "react";
import {createRoot}from 'react-dom/client';
import "./index.css";
import "bootstrap/dist/css/bootstrap.min.css";
import App from "./App";
import SimpleReactLightbox from "simple-react-lightbox";
import * as serviceWorker from "./serviceWorker";

import { Provider } from "react-redux";
import rootReducer from "./store/reducers";
import { createStore } from "redux";
const store = createStore(
  rootReducer,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);

const root = createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <SimpleReactLightbox>
        <App />
      </SimpleReactLightbox>
    </Provider>
  </React.StrictMode>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
